'use client'

import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useRouter } from 'next/navigation'

export const useHomeRedirect = () => {
	const router = useRouter()
	const {
		country: { countryISO, languageISO },
	} = useMasterData()
	const url = `/${countryISO}/${languageISO}`.toLocaleLowerCase()

	const homeReplace = (disableSPA = true): void => {
		if (disableSPA) {
			window.location.replace(url)
		} else {
			router.replace(url)
		}
	}

	const homeNavigate = (disableSPA = true): void => {
		if (disableSPA) {
			window.location.assign(url)
		} else {
			router.push(url)
		}
	}

	return { homeReplace, homeNavigate }
}
